import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getUserGroup } from '../../services/userGroupService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import GroupUsersTab from './tab-pages/GroupUsersTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function UserGroupDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [group, setGroup] = useState(null);
  const [activeTab, setActiveTab] = useState('members');

  useEffect(() => {
    getUserGroup(id)
      .then((res) => setGroup(res.data?.data))
      .catch(() => {});
  }, [id]);

  const tabs = [
    { key: 'members', label: t('userGroup.tabMembers') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('userGroup.title'), path: '/user-groups' },
          { label: group?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'members' && (
          <GroupUsersTab
            groupId={id}
            isAllUsers={group?.isAllUsers}
            groupType={group?.groupType}
            criteria={group?.criteria}
          />
        )}
      </TabContent>
    </PageContainer>
  );
}
